import { AppUrls } from '../../app/AppUrls';
import { ChangeContentByUrlPathAction, SearchActionTypes } from './ActionTypes';

export function changeContentByUrlPath(searchTerm: string, urlPath: string, urls: AppUrls, filters: string): ChangeContentByUrlPathAction {
  return {
    type: SearchActionTypes.CHANGE_CONTENT_BY_URL_PATH,
    searchTerm,
    urlPath,
    urls,
    filters,
  };
}
